import { createFileRoute } from "@tanstack/react-router"
import { createTeamViewStaticData } from "src/views/CreateTeamView/constants"
import { CreateTeamView } from "src/views/CreateTeamView/CreateTeamView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/teams/create")({
	component: CreateTeamView,
	staticData: createTeamViewStaticData,
})
